<template>
  <div>
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }"
          >Back</router-link
        >
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px">
              <h2 class="listing-page-title">About Us</h2>
              <p class="listing-page-desc">Insurance Bazaar Pvt. Ltd</p>
              <small class="insurance-aggregator" hidden>Aggregator</small>

            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img
              class="img-fluid"
              alt="icon"
              :src="require('@/assets/images/claim-policy-right-img.svg')"
            />
          </div>
        </div>
      </div>

      <div class="container article-box">
        <div class="row">
          <div class="col-12">
            <p class="about_new_header">
              Insurance Bazaar Pvt. Ltd. is a Digital Insurance Aggregator. Insurance Bazaar is a multi-line Digital Insurance
              Aggregator with its Head Office located in Lahore, Pakistan. The
              company has been founded by veteran Insurance Professionals and is
              run by a team of dynamic Insurance and Technology Professionals.
            </p>
            <p><b>Making End to End Insurance Journey Digital……….!</b></p>
            <p>
              Digital technology is a new force that is driving massive changes
              around all industries around the globe. For insurance sector too,
              the changing landscape has led to a flurry of technological
              advancements.
            </p>
            <p>
              In Pakistan, <b>Insurance Bazaar</b> is taking the lead in
              introducing a new digital era in insurance that has the potential
              to change the way customers interact with an Insurance Process.
            </p>
            <p>
              The customers find it difficult to understand the insurance
              processes with traditional approaches such as buying, renewing or
              lodging a claim. <b>Insurance Bazaar</b> is bridging this gap
              through its digital platforms to provide the convenience to
              customers in communicating their insurance needs.
            </p>
            <p>
              <b>Insurance Bazaar</b> is offering a digital insurance market
              place where Customers can address their insurance needs 24/7/365
              at their convenience and can;
            </p>

            <ul>
              <li>
                Get comparison of best available insurance plans of multiple
                companies simultaneously
                <ul>
                  <li>Price Comparison</li>
                  <li>Benefits Comparison</li>
                  <li>Exclusion and deductible comparison</li>
                  <li>Insurance Companies Ranking</li>
                </ul>
              </li>
              <li>
                Buy Insurance Policy of their choice Online and Hassle-free
              </li>
              <li>Complete paperless experience with digital documentation</li>
              <li>Make Online Payments</li>
              <li>Request the policy servicing digitally</li>
              <li>
                Lodge claims any time without having to visit Insurance
                Companies’ offices
              </li>
              <li>Lodge any Complaint and provide Feedbacks</li>
              <li>Digitally renew your policy from within the App</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
body {
  font-family: "Futura PT";
}
h1 {
  font-family: "Futura PT";
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.27;
  letter-spacing: normal;
  text-align: left;
  color: #ba0c2f;
}
h4 {
  font-family: "Futura PT Medium";
}
.data-row:hover {
  box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.data-row p {
  color: #5b6770;
  font-family: "Futura PT Book";
}
ul {
  list-style: none;
}
li {
  position: relative;
  color: var(--text-color);
  font-family: "Avenir Book";
}
li:before {
  content: "•";
  position: absolute;
  left: -1em;
  color: var(--secondary-color);
}
table > tbody > tr,
.data-row {
  margin: 10px 0;
  padding: 20px 30.7px 20px 15px;
  border-radius: 10px;
  border: solid 1px #dedada;
  background-color: #ffffff;
}
.data-row .action-area i {
  width: 7.9px;
  height: 14.6px;
  color: #5b6770;
}
table > tbody > tr > th > img,
.data-img img {
  width: 74px;
  height: 48px;
  border-radius: 7px;
}
label {
  position: absolute;
  top: 0;
  right: 1px;
  bottom: 1px;
  left: 0.5em;
  z-index: 1;
  height: 1em;
  font-size: 13px;
  line-height: 3.5em;
  color: #999;
  white-space: nowrap;
  cursor: text;
  transition: all 0.1s ease;
}
.input-placeholder:focus ~ label,
.input-placeholder:valid ~ label {
  font-size: 11px;
  left: 10px;
  top: -10px;
}
.input-placeholder:valid ~ label {
  color: green;
}
.input-placeholder:focus:invalid ~ label {
  color: red;
}
iframe {
  width: 100% !important;
}
@media (max-width: 768px) {
  iframe {
    max-height: 250px;
  }
}
.article-box p {
  font-family: "Avenir Book";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: var(--text-color);
}
.insurance-aggregator{
  position: relative;
    left: 15px;
    top: -13px;
    color: var(--secondary-color);
}
.about_new_header{
      text-align: justify;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 2rem;
    border: 2px solid gainsboro;
    padding: 34px;
    border-radius: 10px;
    color: #3c4a56;
    box-shadow: 0rem 0rem 0.35rem 0rem gainsboro;

}
</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue